import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import {setStockoutreqSorting} from 'store/slice/ManufSlice';

export default function StockoutreqListTableHeader(){
  const dispatch = useDispatch();
  const {mobileView} =useSelector((state) => state.menu);
  const {sorting} = useSelector((state) => state.manufslice.stockoutreqDashboard);
  
  const handleColumnClick = (column) => {
  const currentSorting = sorting.column === column ? !sorting.asc : true;
    dispatch(setStockoutreqSorting({ column, asc: currentSorting }));     
  }
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>

            {/* <HEADER - CELLS/> */}
        
                        <Grid item lg={1} xs={1} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('id')}> S-Out # </Typography></Grid>
                        <Grid item lg={2} xs={1} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('initiatedby')}> Initiated By </Typography></Grid>
                        <Grid item lg={8} xs={8} >
                          <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%' }}>
                            <Grid item lg={3} xs={6} >
                              <Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('id')}> Product Name </Typography>
                            </Grid>
                            <Grid item lg={3} xs={6} >
                              <Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('id')}> Total Quantity </Typography>
                            </Grid>
                            <Grid item lg={6} xs={6} >
                              <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%' }}>
                                <Grid item lg={2} xs={6} >
                                  <Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('id')}> Ord # </Typography>
                                </Grid>
                                <Grid item lg={8} xs={6} >
                                  <Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('id')}> Party Name </Typography>
                                </Grid>
                                <Grid item lg={2} xs={6} >
                                  <Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('id')}> Qty </Typography>
                                </Grid>
                                </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

      </Grid>
      
    )
}